import { InfoModal } from 'components/ModalWindows/InfoModal/InfoModal';

interface Props {
  onClose: () => void;
}

export const DialogSettlementSaveSuccess = ({ onClose }: Props) => {
  return (
    <InfoModal title="Success" message="Settlement updated" onClose={onClose} />
  );
};
